<template>
  <div class="container">
    <div class="row">
      <div>
        <div class="col-lg-12 img">
          <div class="col-lg-12 box ">طراحی تجربه کاربری</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  components: {},
  name: "C800",
};
</script>


<style scoped>
.img {
  background-image: linear-gradient(to bottom, rgba(215, 221, 255, 0) 60%, rgba(0, 41, 200, 1) 110%),
  url('https://limoostudio.com/rtl-theme/grupi/wp-content/uploads/2021/06/g25-370x245.jpg');
  width: 370px;
  height: 245px;
}

.img:hover {
  background-image: url('https://limoostudio.com/rtl-theme/grupi/wp-content/uploads/2021/06/g25-370x245.jpg');
  width: 370px;
  height: 245px;
  cursor: pointer;

}

.box {

  font-size: 16pt;
  background-color: #efefef;
  text-align: center;
  width: 300px;
  height: 65px;
  transform: translate(-6.5%, 325%);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1px;
}
</style>
